<app-divider *ngIf="isCart"></app-divider>

<table class="summary-detail w-full text-vtmn-play-content-quiet">
  <caption class="hidden">
    {{
      'checkout.cart.label' | translate
    }}
  </caption>
  <thead class="hidden">
    <tr>
      <th id="quantity">
        {{ 'checkout.summary.table.header.quantity' | translate }}
      </th>
      <th id="price">
        {{ 'checkout.summary.table.header.price' | translate }}
      </th>
    </tr>
  </thead>

  <tbody>
    <!-- Adults -->
    <tr *ngIf="item?.numberOfAdults">
      <td headers="quantity">
        {{ item.numberOfAdults }}
        {{ numberOfPlaces(item.numberOfAdults, 'adult') }}
      </td>
      <td class="text-right" headers="price">
        <span>{{
          getAdultsTotalPrice(item) | displayPrice: item.currency
        }}</span>
      </td>
    </tr>

    <!-- Children -->
    <tr *ngIf="item?.numberOfChildren">
      <td headers="quantity">
        {{ item.numberOfChildren }}
        {{ numberOfPlaces(item.numberOfChildren, 'children') }}
      </td>
      <td class="text-right" headers="price">
        <span>{{
          getChildrenTotalPrice(item) | displayPrice: item.currency
        }}</span>
      </td>
    </tr>
  </tbody>
</table>
<app-tax-included
  [isCart]="isCart"
  [item]="item"
  [showExternalPayment]="showExternalPayment"
  [taxes]="taxes"
  [isVatDisplayed]="isVatDisplayed"
  [isVatShown]="isVatShown"
  [taxesDetail]="taxesDetail"
></app-tax-included>
